import React, { Component } from 'react'
import SizeIndicators from './size-indicators'
import CardContainer from './card-container'
import SizeHolder from './size-holder'
import CardTitle from '../card-title/card-title'
import './size-indicator.css'
import { getCall } from '../../../../helpers/api'

class SizeIndicatorExample extends Component {

    constructor(props) {
        super(props)
        this.state = {
            sizes: []
        }
        this.renderSizeIndicator = this.renderSizeIndicator.bind(this)
    }

    async componentDidMount() {
        const sizes = await getCall("/size/getall")
        await this.setState({ sizes: sizes.data })
    }

    renderSizeIndicator(s, index) {
        let size = "0px"
        let px = "0px"
        if (s.sizeName === "Çok minik") {
            size = "100px"
            px = "13px"
        }
        else if (s.sizeName === "Minik") {
            size = "120px"
            px = "14px"
        }
        else if (s.sizeName === "Orta") {
            size = "140px"
            px = "15px"
        }
        else if (s.sizeName === "Uzun") {
            size = "160px"
            px = "16px"
        }
        else if (s.sizeName === "Çok uzun") {
            size = "180px"
            px = "17px"
        }
        else if (s.sizeName === "Kocaman") {
            size = "200px"
            px = "18px"
        }

        return <SizeIndicators key={index} history={this.props.history} width={size} height={size} text1={s.sizeName} text2={s.size} px={px} />

    }

    render() {
        return (
            <CardContainer>
                <CardTitle title="Bitkinin Boyunu Seçin" />
                <div style={{marginBottom: 60}}></div>
                <SizeHolder>
                    {this.state.sizes.map((s, index) => (
                        this.renderSizeIndicator(s, index)
                    ))}
                </SizeHolder>
            </CardContainer>
        )
    }
}

export default SizeIndicatorExample
